
export default {
  namespaced: true,
  state: {
    modalIsOpen: 0,
    sideMenuIsOpen: false,
    initializedData: false
  },
  getters: {
    modalIsOpen: state => state.modalIsOpen,
    sideMenuIsOpen: state => state.sideMenuIsOpen,
    initializedData: state => state.initializedData
  },
  actions: {
    modalOpened: ({ commit }) => {
      commit('modalOpened')
    },
    modalClosed: ({ commit }) => {
      commit('modalClosed')
    },
    updateModalIsOpenStatus: ({ commit }, modalStatus) => {
      commit('setModalIsOpen', modalStatus)
    },
    setSideMenuIsOpen: ({ commit }, sideMenuStatus) => {
      commit('setSideMenuIsOpen', sideMenuStatus)
    },
    initializeData: ({ dispatch, commit, getters, rootGetters }) => {
      if (!getters.initializedData) {
        dispatch('UsersStore/fetchUserLogged', rootGetters['LoginStore/loggedUserId'], { root: true })
        dispatch('TransactionsStore/fetchVatTypes', null, { root: true })
        dispatch('CategoriesStore/fetchCategories', false, { root: true })
        dispatch('CompanyStore/ExpensesSettingsStore/fetchMileageCategories', false, { root: true })
        dispatch('CompanyStore/ExpensesSettingsStore/fetchDietCategories', false, { root: true })
        dispatch('CompanyStore/fetchOfficeFormConfigurations', null, { root: true })
        dispatch('ConfigStore/fetchPrivateConfig', true, { root: true })
        dispatch('ConfigStore/fetchPublicConfig', true, { root: true })
        dispatch('ConfigStore/fetchCurrencies', true, { root: true })
        dispatch('TransactionsStore/getFilteredViews', null, { root: true })
        commit('setInitializedData', true)
      }
    },
    setInitializedData: ({ commit }, value) => {
      commit('setInitializedData', value)
    },
    clearStore: ({ commit }) => {
      commit('setModalIsOpen', 0)
      commit('setSideMenuIsOpen', false)
      commit('setInitializedData', false)
    }
  },
  mutations: {
    modalOpened: (state) => {
      state.modalIsOpen++
      if (state.modalIsOpen > 0) {
        window.HubSpotConversations.widget.remove()
      }
    },
    modalClosed: (state) => {
      state.modalIsOpen--
      if (state.modalIsOpen <= 0) {
        window.HubSpotConversations.widget.load({ widgetOpen: false })
      }
    },
    setSideMenuIsOpen: (state, payload) => {
      state.sideMenuIsOpen = payload
    },
    setInitializedData: (state, payload) => {
      state.initializedData = payload
    }
  }
}
